import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../../hooks/useApi';
import { TemplatesResponse,Template } from '../rtm_plan/index.type';

const useAllTemplate = () => {
  const [TemplateData, setTemplateData] = React.useState<Template[]>([]);
  
  const { loading: TemplateDataLoading, makeApiCall } = useApi({
    url: `/rtm/template/transmission`,
    method: 'GET',
  });


  const getTemplateData = async () => {
    const { response, error } = await makeApiCall<undefined,TemplatesResponse>();
    if (response?.status === 'success') {
    setTemplateData(response.data)
    }

    if (response?.status === 'fail') {
        return
    }

    if (error) toast.error('Something went wrong while fetching clinic data. Please try again later');
  };

  return {
    TemplateData,
    getTemplateData,
    TemplateDataLoading,
  };
};

export default useAllTemplate;
